import Vue from 'vue'
import VueRouter from 'vue-router'
import Schedule from "@/pages/Schedule.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'ScheduleTime',
    component: Schedule
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
